// Piloto §F-traceability + phase 17 (2026-05-13) — Reference ranges per
// (breed, destination) for the public traceability report.
//
// ⚠ IMPORTANTE — estes valores son ESTIMACIÓNS APROXIMADAS para que o
// piloto poida amosar a feature visualmente. NON son datos oficiais.
//
// Fontes pendentes de integrar oficialmente (V2):
//   • AGACA — Asociación Galega de Cooperativas Agroalimentarias.
//     Estatísticas anuais por raza para sector leiteiro.
//   • ACRUGA — Asociación Nacional de Criadores de Gando Vacún Selecto da
//     Raza Rubia Galega. Parámetros oficiais Rubia Galega.
//   • IGP Ternera Gallega — Consello Regulador. Pesos canal típicos.
//   • SITRAN agregados — datos nacionais MAPA por raza/idade.
//
// As táboas que seguen están baseadas en literatura zootécnica + observación
// común en explotacións galegas. Substituír cando lograr convenio coas
// asociacións.
export const BREED_REFERENCES = [
    // ─── Rubia Galega — BEEF ───────────────────────────────────────────────
    {
        breed: 'Rubia Galega',
        destination: 'BEEF',
        age_first_calving_months: { min: 24, max: 30 },
        carcass_weight_kg: { min: 240, max: 320 },
        slaughter_age_months: { min: 8, max: 14 },
        adult_weight_kg: { min: 550, max: 750 },
        calvings_per_year_optimal: 1.0,
    },
    // ─── Holstein / Frisona — DAIRY ────────────────────────────────────────
    {
        breed: 'Holstein / Frisona',
        destination: 'DAIRY',
        age_first_calving_months: { min: 23, max: 27 },
        carcass_weight_kg: null,
        slaughter_age_months: null, // sacrificiadas só ao remate vida produtiva
        adult_weight_kg: { min: 600, max: 750 },
        calvings_per_year_optimal: 1.0,
    },
    // ─── Pardo-Suíza — DAIRY ───────────────────────────────────────────────
    {
        breed: 'Pardo-Suíza',
        destination: 'DAIRY',
        age_first_calving_months: { min: 26, max: 30 },
        carcass_weight_kg: null,
        slaughter_age_months: null,
        adult_weight_kg: { min: 600, max: 700 },
        calvings_per_year_optimal: 1.0,
    },
    // ─── Limusín — BEEF ────────────────────────────────────────────────────
    {
        breed: 'Limusín',
        destination: 'BEEF',
        age_first_calving_months: { min: 25, max: 32 },
        carcass_weight_kg: { min: 260, max: 360 },
        slaughter_age_months: { min: 9, max: 16 },
        adult_weight_kg: { min: 600, max: 800 },
        calvings_per_year_optimal: 1.0,
    },
    // ─── Charolais — BEEF ──────────────────────────────────────────────────
    {
        breed: 'Charolais',
        destination: 'BEEF',
        age_first_calving_months: { min: 26, max: 34 },
        carcass_weight_kg: { min: 280, max: 400 },
        slaughter_age_months: { min: 10, max: 18 },
        adult_weight_kg: { min: 700, max: 950 },
        calvings_per_year_optimal: 1.0,
    },
    // ─── Cachena (autóctona) — BEEF / autóctona ───────────────────────────
    {
        breed: 'Cachena',
        destination: 'BEEF',
        age_first_calving_months: { min: 30, max: 42 },
        carcass_weight_kg: { min: 140, max: 200 },
        slaughter_age_months: { min: 12, max: 24 },
        adult_weight_kg: { min: 350, max: 500 },
        calvings_per_year_optimal: 1.0,
    },
];
const BREED_REF_INDEX = new Map(BREED_REFERENCES.map((r) => [`${r.breed.toLowerCase()}|${r.destination}`, r]));
/**
 * Resolve the reference card for a (breed, destination) pair. Returns null
 * when we don't have data — the public template should then suppress the
 * "rango habitual" annotations entirely (better than showing wrong numbers).
 */
export function getBreedReference(breed, destination) {
    if (!breed)
        return null;
    return BREED_REF_INDEX.get(`${breed.toLowerCase()}|${destination}`) ?? null;
}
/** Indicates that we don't have an exact reference; the UI must mark this. */
export const REFERENCE_DATA_DISCLAIMER = 'Datos aproximados — pendente integración con AGACA / ACRUGA';
//# sourceMappingURL=breed-references.js.map